<template>
  <div>
    <el-tabs type="border-card">
      <!--集货码详情-->
      <el-tab-pane :label="$t('collectionCenter.PickupCodeDetails')">
        <div class="constant-detail">
          <el-form size="small">
            <el-row :gutter="10">
              <el-col :span="12">
                <!--集货码-->
                <el-form-item :label="$t('collectionCenter.PickupCode') + '：'">
                  <span>{{ rowData.code }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <!--所属网点-->
                <el-form-item :label="$t('collectionCenter.belongD') + '：'">
                  <span>{{ rowData.siteName }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <!--下一站-->
                <el-form-item :label="$t('GlobalSetObj.nextStation') + '：'">
                  <span>{{ rowData.nextStationName }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <!--创建时间-->
                <el-form-item :label="$t('collectionCenter.CreationTime') + '：'">
                  <span>{{ rowData.createTime }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <!--创建人-->
                <el-form-item :label="$t('collectionCenter.creator') + '：'">
                  <span>{{ rowData.createUserName }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <!--状态-->
                <el-form-item :label="$t('collectionCenter.stateZT') + '：'">
                  <el-tag v-if="rowData.status === 0" type="info">
                    {{ $t('collectionCenter.NotBound') }}
                  </el-tag>
                  <el-tag v-if="rowData.status === 1" type="success">
                    {{ $t('collectionCenter.Bound') }}
                  </el-tag>
                  <el-tag v-if="rowData.status === 2" type="primary">
                    {{ $t('GlobalSetObj.Carregado') }}
                  </el-tag>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <!--已绑定袋数-->
                <el-form-item :label="$t('collectionCenter.BoundBags') + '：'">
                  <span>{{ rowData.boundBagCount }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <!--已绑定包裹数-->
                <el-form-item :label="$t('collectionCenter.BoundPackages') + '：'">
                  <span>{{ rowData.boundPackageCount }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <!--总重量-->
                <el-form-item :label="$t('collectionCenter.totalWeight') + '：'">
                  <span>{{ rowData.totalWeight }}KG</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <!--总开票金额(BRL)-->
                <el-form-item :label="$t('collectionCenter.TotalInvoiceAmount') + '(BRL)：'">
                  <span>{{ rowData.totalInvoiceAmount }}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-tab-pane>
      <!--已绑定袋号-->
      <el-tab-pane :label="$t('collectionCenter.BoundBagNumber')">
        <div class="constant-detail">
          <bagNumber :row-data="rowData" />
        </div>
      </el-tab-pane>
      <!--已绑定包裹号-->
      <el-tab-pane :label="$t('collectionCenter.BoundPackageNumber')">
        <div class="constant-detail">
          <packageNumber :row-data="rowData" />
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import bagNumber from './bagNumber.vue';
import packageNumber from './packageNumber.vue';
export default {
  name: 'Detail',
  components: {
    bagNumber,
    packageNumber
  },
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  methods: {
  }
};
</script>

<style>
.constant-detail {
  height: calc(100vh - 100px);
  margin: -15px;
  overflow: auto;
  padding: 20px;
}
.el-drawer .el-drawer__header {
  margin-bottom: 0;
}
</style>
